export default __webpack_public_path__ + "static/matcap0-8b3d89ff90a49bea9667f5400a050934.jpeg";